var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "popup-vat-manager" },
    [
      _c(
        "CompassDialog",
        {
          staticClass: "popup-vat-manager",
          attrs: {
            visible: _vm.showModal,
            title: _vm.$t.__(
              "settings.taxes.popup.VatPopupManager.edit_default_tax"
            ),
            closeOnClickOverlay: false
          },
          on: {
            "update:visible": function($event) {
              _vm.showModal = $event
            },
            closed: function($event) {
              return _vm.closePopup()
            }
          }
        },
        [
          _c("template", { slot: "default" }, [
            _c(
              "div",
              { staticClass: "dialog__default" },
              [
                _c("div", { staticClass: "alert alert-info mt-0" }, [
                  _c("p", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$l10n.__(
                            "En l’absence de traduction, la langue par défaut sera utilisée"
                          )
                        ) +
                        "\n                    "
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.languages.length > 1
                  ? [
                      _c(
                        "div",
                        { staticClass: "mb-3 select__lang-wrapper" },
                        [
                          _c(
                            "div",
                            { staticClass: "mb-1 typographies-heading-h4" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$l10n.__("Langue")) +
                                  "\n                        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticClass: "wp-10",
                              model: {
                                value: _vm.selectedLanguageId,
                                callback: function($$v) {
                                  _vm.selectedLanguageId = $$v
                                },
                                expression: "selectedLanguageId"
                              }
                            },
                            [
                              _c("template", { slot: "prefix" }, [
                                _vm.selectedLanguageFlag
                                  ? _c("img", {
                                      staticClass: "mt-2 h-2",
                                      attrs: {
                                        src:
                                          "/ressources/public/img/flags/" +
                                          _vm.selectedLanguageFlag +
                                          ".png"
                                      }
                                    })
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.languages, function(item) {
                                return _c(
                                  "el-option",
                                  {
                                    key: item.id,
                                    attrs: { label: item.lang, value: item.id }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flex flex-level" },
                                      [
                                        item.flag
                                          ? _c("img", {
                                              staticClass: "pr-2",
                                              attrs: {
                                                src:
                                                  "/ressources/public/img/flags/" +
                                                  item.flag +
                                                  ".png"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("span", [_vm._v(_vm._s(item.lang))])
                                      ]
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "table",
                  { staticClass: "vat-manager-table mb-3" },
                  [
                    _c("thead", { staticClass: "semibold" }, [
                      _c("tr", [
                        _c(
                          "th",
                          { staticClass: "vat-manager-table__wrapper" },
                          [
                            _c("td", {
                              staticClass: "vat-manager-table__switch"
                            }),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "vat-manager-table__name" },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.$l10n.__("Nom")) +
                                    "\n                                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.$l10n.__("Valeur")) +
                                  "\n                                "
                              )
                            ])
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "SaasDraggable",
                      {
                        staticClass: "tbody noEcoTaxes",
                        attrs: {
                          dragClass: "vat-popup-manager__item-draggable"
                        },
                        model: {
                          value: _vm.listNoEcoTaxes,
                          callback: function($$v) {
                            _vm.listNoEcoTaxes = $$v
                          },
                          expression: "listNoEcoTaxes"
                        }
                      },
                      _vm._l(_vm.listNoEcoTaxes, function(item, index) {
                        return _c(
                          "tr",
                          {
                            key: item.id,
                            ref: "noEcoTaxes" + index,
                            refInFor: true,
                            staticClass: "vat-popup-manager__item-draggable"
                          },
                          [
                            _c(
                              "td",
                              { ref: "label", refInFor: true },
                              [
                                _c("VatItem", {
                                  attrs: {
                                    value: item,
                                    languageId: _vm.selectedLanguageId
                                  },
                                  on: {
                                    blur: function() {
                                      _vm.checkItem(item, "noEcoTaxes" + index)
                                    },
                                    needRateChecking: function($event) {
                                      return _vm.checkIfRateAlreadyExist(
                                        item.rate,
                                        index
                                      )
                                    },
                                    "remove-taxe": function($event) {
                                      return _vm.removeTaxe(item)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("CompassButton", {
                  ref: "buttonAddVat",
                  attrs: {
                    label: _vm.$t.__(
                      "settings.taxes.popup.VatPopupManager.add_tax"
                    )
                  },
                  on: { click: _vm.addTaxe }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex-row ai-center mt-6 mb-3 typographies-heading-h3"
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$l10n.__("Ecotaxe")) +
                        "\n                    "
                    ),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: _vm.$t.__(
                            "settings.taxes.popup.VatPopupManager.contact_support"
                          ),
                          effect: "dark",
                          placement: "bottom-start",
                          popperClass: "tooltip-eco-tax__popper"
                        }
                      },
                      [
                        _c("CompassIcon", {
                          attrs: {
                            icon: "help-circle-fill",
                            size: "small",
                            type: "primary"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "mb-3" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Ces taxes sont utilisées lorsque vous activez l’écotaxe sur un produit. Vous les retrouvez dans les calculs de l’écotaxe de vos documents."
                        )
                      ) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "table",
                  { staticClass: "vat-manager-table eco-taxes mb-0" },
                  [
                    _c("thead", { staticClass: "semibold" }, [
                      _c("tr", [
                        _c("th", { staticClass: "eco-taxes__wrapper" }, [
                          _c("td", { staticClass: "eco-taxes__header-name" }, [
                            _vm._v(_vm._s(_vm.$l10n.__("Nom")))
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.$l10n.__("Valeur")))])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      { staticClass: "tbody" },
                      _vm._l(_vm.listEcoTaxes, function(item, index) {
                        return _c(
                          "tr",
                          {
                            key: index,
                            ref: "ecoTaxes" + index,
                            refInFor: true
                          },
                          [
                            _c(
                              "td",
                              { ref: "label", refInFor: true },
                              [
                                _c("VatItem", {
                                  attrs: {
                                    value: item,
                                    languageId: _vm.selectedLanguageId
                                  },
                                  on: {
                                    blur: function() {
                                      _vm.checkItem(item, "noEcoTaxes" + index)
                                    },
                                    needRateChecking: function($event) {
                                      return _vm.checkIfRateAlreadyExist(
                                        item.rate,
                                        index
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]
                )
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("template", { slot: "footer" }, [
            _c(
              "div",
              { staticClass: "dialog__footer" },
              [
                _c("CompassButton", {
                  ref: "buttonCancel",
                  attrs: {
                    label: _vm.$t.__("common.actions.cancel"),
                    type: "secondary"
                  },
                  on: { click: _vm.closePopup }
                }),
                _vm._v(" "),
                _c("CompassButton", {
                  ref: "buttonSubmit",
                  staticClass: "ml-3",
                  attrs: {
                    disabled: _vm.cantSubmit,
                    label: _vm.$t.__("common.actions.save")
                  },
                  on: { click: _vm.onSubmitForm }
                })
              ],
              1
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _vm.shouldDisplayWarningRatePopup
        ? _c(
            "CompassDialog",
            {
              attrs: {
                visible: _vm.showModal2,
                size: "small",
                title: _vm.$t.__(
                  "settings.taxes.popup.VatPopupManager.create_existing_VAT_rate"
                )
              },
              on: {
                "update:visible": function($event) {
                  _vm.showModal2 = $event
                },
                closed: function($event) {
                  _vm.shouldDisplayWarningRatePopup = false
                }
              }
            },
            [
              _c("template", { slot: "header" }, [
                _c("div", { staticClass: "dialog__header" }, [
                  _c("div", { staticClass: "dialog__header--title" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "dialog__header--close" },
                    [
                      _c("CompassIconButton", {
                        attrs: { icon: "close" },
                        on: {
                          click: function($event) {
                            return _vm.$emit("close")
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("template", { slot: "default" }, [
                _c(
                  "div",
                  { staticClass: "dialog__default" },
                  [
                    _c("CompassAlert", {
                      attrs: {
                        type: "warning",
                        description: _vm.$t.__(
                          "settings.taxes.popup.VatPopupManager.action_could_cause_problems"
                        ),
                        showIcon: false,
                        action: null,
                        showClose: false
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("template", { slot: "footer" }, [
                _c(
                  "div",
                  { staticClass: "dialog__footer" },
                  [
                    _c("CompassButton", {
                      attrs: { label: _vm.$t.__("common.actions.confirm") },
                      on: {
                        click: function($event) {
                          _vm.shouldDisplayWarningRatePopup = false
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }